module.exports = __webpack_public_path__ + "media/img/decorations/vacancies-img-right-bd64fd90fcc384aed9eedad9bbcf13b1.svg";